// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app'
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/analytics'
import 'firebase/messaging'

firebase.initializeApp(process.env.FIREBASE_CONFIG)
const notSupported = () => Promise.reject('Unsupported firebase messaging')
let _messaging = {
  onMessage: notSupported,
  onTokenRefresh: notSupported,
  getToken: notSupported,
  deleteToken: notSupported
}
if (firebase.messaging.isSupported()) {
  _messaging = firebase.messaging()
}
export const messaging = _messaging
